// Consolidate duplicate fbclid logic
function getQueryParam(param) {
	return new URLSearchParams(location.search).get(param);
}

function setStorageIfNew(key, value) {
	if (!localStorage.getItem(key) && value) {
		localStorage.setItem(key, value);
	}
}

// Initialize at load
if (window.location.href.includes('?staff_user')) {
	localStorage.setItem('staff_user', 'true');
}
setStorageIfNew('fbclid', getQueryParam('fbclid'));
setStorageIfNew('msclkid', getQueryParam('msclkid'));

$(document).on('globo.form.loaded', handle_lv);

$(document).ready(function () {
	var $formElements = jQuery('form.g-container input, form.g-container select');
	$formElements.on('change', handle_lv);

	// Reattach handlers at intervals
	[5000, 15000].forEach(delay => {
		setTimeout(() => {
			var $formElements = jQuery('form.g-container input, form.g-container select');
			$formElements.off('change', handle_lv).on('change', handle_lv);
		}, delay);
	});
});

function handle_lv() {
	if (typeof window.handle_lv_gads === 'function') {
		try {
			window.handle_lv_gads();
		} catch (error) {
			console.error('Error in handle_lv_gads:', error);
		}
	}
}

function handle_lv_gads() {
	try {
		const keyLabelEl = $('[name=_keyLabel]');
		const globForm = JSON.parse(keyLabelEl.val());
		const params = ['fbclid', 'msclkid', 'uuid'];

		params.forEach(param => {
			if ($(`#${param}`).length === 0) {
				globForm[param] = param;
				let value = localStorage.getItem(param) || '';
				if (param === 'uuid' && !value) {
					value = _getDeviceFingerprint();
					window._uuid = value;
				}
				keyLabelEl.after(`<input type="hidden" data-type="fixed" id="${param}" name="${param}" value="${value}">`);
			} else if (param !== 'uuid') {
				const stored = localStorage.getItem(param);
				if (stored) {
					document.querySelector(`[id^='globo-formbuilder'] #${param}`).value = stored;
				}
			}
		});

		keyLabelEl.val(JSON.stringify(globForm));
	} catch (error) {
		console.error('Error in handle_lv_gads:', error);
	}


	try {
		if ($('#lead_source').length == 0) {
			const $key = $('[name=_keyLabel]');
			const globForm = JSON.parse($key.val() || '{}');
			globForm.lead_source = 'lead_source';
			$key.val(JSON.stringify(globForm));
			window.lead_source = JSON.stringify(window.getTrackingData());
			$('<input>', { type: 'hidden', 'data-type': 'fixed', id: 'lead_source', name: 'lead_source', value: window.lead_source }).insertAfter($key);
			console.log($('#lead_source').val())
		}
		
		
		if ($('#lead_campaign').length == 0) {
			const $key = $('[name=_keyLabel]');
			const globForm = JSON.parse($key.val() || '{}');
			globForm.lead_campaign = 'lead_campaign';
			$key.val(JSON.stringify(globForm));
			window.lead_campaign = JSON.stringify(window.getTrackingData().utm_campaign);
			$('<input>', { type: 'hidden', 'data-type': 'fixed', id: 'lead_campaign', name: 'lead_campaign', value: window.lead_campaign }).insertAfter($key);
			console.log($('#lead_campaign').val())
		}
	} catch (error) {
		
	}
}

function _getDeviceFingerprint() {
	const data = [
		navigator.userAgent,
		navigator.language,
		`${screen.width}x${screen.height}`,
		screen.colorDepth,
		navigator.hardwareConcurrency || 'unknown',
		navigator.deviceMemory || 'unknown',
		new Date().getTimezoneOffset(),
		navigator.platform,
		navigator.vendor || 'unknown'
	].join('|||');

	const hash = data.split('').reduce((h, c) => {
		h = ((h << 5) - h) + c.charCodeAt(0);
		return h & h;
	}, 0).toString(16);

	return `${hash.replace(/-/g, '')}_${Date.now()}`;
}










(function () {
	// List of tracking parameters to capture
	const trackingParams = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'utm_id',
		'gclid',        // Google Click ID
		'fbclid',       // Facebook Click ID
		'msclkid',      // Microsoft Click ID
		'ttclid',       // TikTok Click ID
		'twclid',       // Twitter Click ID
		'li_fat_id',    // LinkedIn Click ID
		'dclid',        // DoubleClick ID
		'wbraid',       // Google Web-to-App
		'gbraid',       // Google App-to-Web
		'srsltid',      // Google Merchant Center
		'epik',         // Pinterest
		'irclickid',    // Impact Radius
		'ref'           // Generic referral
	];

	const STORAGE_KEY = 'tracking_data';
	const COOKIE_DAYS = 90;

	// Cookie helpers
	function setCookie(name, value, days) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
	}

	function getCookie(name) {
		return document.cookie.split('; ').reduce((r, v) => {
			const parts = v.split('=');
			return parts[0] === name ? decodeURIComponent(parts[1]) : r;
		}, '');
	}

	// Load existing data (prefer localStorage, fall back to cookie)
	let stored = {};
	try {
		const ls = localStorage.getItem(STORAGE_KEY);
		if (ls) stored = JSON.parse(ls) || {};
	} catch (e) { }

	if (!Object.keys(stored).length) {
		try {
			const ck = getCookie(STORAGE_KEY);
			if (ck) stored = JSON.parse(ck) || {};
		} catch (e) { }
	}

	// Read current URL params
	const urlParams = new URLSearchParams(window.location.search);
	let updated = false;

	trackingParams.forEach(param => {
		const value = urlParams.get(param);
		if (value) {
			stored[param] = value;
			updated = true;
		}
	});

	// Store landing page + referrer on first visit only
	if (urlParams.toString() || !stored.landing_page) {
		if (!stored.landing_page) {
			stored.landing_page = window.location.href;
			stored.referrer = document.referrer || 'direct';
			updated = true;
		}
	}

	// Persist if anything changed (or on first run)
	if (updated || !localStorage.getItem(STORAGE_KEY)) {
		stored.timestamp = new Date().toISOString();
		const json = JSON.stringify(stored);

		try { localStorage.setItem(STORAGE_KEY, json); } catch (e) { }
		setCookie(STORAGE_KEY, json, COOKIE_DAYS);
	}

	// Helper to read it back anywhere
	window.getTrackingData = function () {
		try {
			const ls = localStorage.getItem(STORAGE_KEY);
			if (ls) return JSON.parse(ls);
		} catch (e) { }
		try {
			const ck = getCookie(STORAGE_KEY);
			if (ck) return JSON.parse(ck);
		} catch (e) { }
		return {};
	};
})();

// var tracking = window.getTrackingData();
// console.table(tracking);
// console.log(tracking.utm_source);
